module["exports"] = [
  "ИП",
  "ООО",
  "ЗАО",
  "ОАО",
  "НКО",
  "ТСЖ",
  "ОП"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/company/prefix.js
 ** module id = 925
 ** module chunks = 0
 **/